<template>
 <a-card :bordered="false">
     <a-table
        :scroll="{ y: 'calc(100vh - 200px)',x:1500}"
        row-key="id"
        :data-source="table.data"
        :columns="table.columns"
        :pagination="table.pagination"
        :loading="table.loading"
        @change="handleTableChange"

        style="width: 100%">
        <span slot="img" slot-scope="text, record">
           <a-avatar :size="80" shape="square" :src="record.coverPath"/>
        </span>
        <span slot="createAt" slot-scope="text, record">
          <time-formatter :time="record.updateAt" format="YYYY-MM-DD"/>
        </span>
        <span slot="updateAt" slot-scope="text, record">
          <time-formatter :time="record.updateAt" format="YYYY-MM-DD"/>
        </span>
      </a-table>
 </a-card>
</template>

<script>
import {
  _queryGoods
} from '@/api/goodsApi.js';

async function getGoodsListByBrandId() {
  this.loading = true;
  const { order } = this.table.sort;
  const result = await _queryGoods({
    brandId: this.brandId,
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction: order === 'ascend' ? 'ASC' : 'DESC',
  });
  if (result) {
    this.table.data = result.content;
  }
  this.loading = false;
  this.table.pagination.total = result.totalElements;
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  if (sorter.field) {
    this.table.sort = {
      prop: sorter.field,
      order: sorter.order,
    };
  }

  this.getGoodsListByBrandId();
}
const columns = [
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },
  },
  {
    title: '商品名',
    dataIndex: 'name',
    width: 150,
    sorter: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '编号',
    dataIndex: 'code',
  },
  {
    title: '价格',
    dataIndex: 'price',

  },
  {
    title: '数量',
    dataIndex: 'quantity'
  }
];
export default {
  name: 'GoodsBrandIdDetail',
  props: {

    brandId: String,

  },
  data() {
    return {
      table: {
        data: [],
        columns,
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        loading: false,
        sort: {
          prop: 'createAt',
          order: 'DESC',
        },
      }
    };
  },
  methods: {
    getGoodsListByBrandId,
    handleTableChange,
  },
  created() {
    if (this.brandId) {
      this.getGoodsListByBrandId();
    }
  }
};
</script>

<style scoped lang="scss">

</style>
